import { getCurrentEnvironment } from '../config/environments'
import { logWithSuffix } from './clientLogger'

let scriptLoaded = false
let scriptLoading = false
let loadPromise: Promise<void> | null = null

export function loadUnbluApi(): Promise<void> {
  // Return existing promise if already loading
  if (loadPromise) {
    return loadPromise
  }

  // Return resolved promise if already loaded
  if (scriptLoaded) {
    return Promise.resolve()
  }

  // Prevent multiple simultaneous loads
  if (scriptLoading) {
    return new Promise((resolve, reject) => {
      const checkLoaded = () => {
        if (scriptLoaded) {
          resolve()
        } else if (!scriptLoading) {
          reject(new Error('Script loading failed'))
        } else {
          setTimeout(checkLoaded, 100)
        }
      }
      checkLoaded()
    })
  }

  scriptLoading = true

  loadPromise = new Promise((resolve, reject) => {
    const environment = getCurrentEnvironment()
    console.debug(`Loading Unblu API from: ${environment.unbluApiUrl}`)

    const existingScript = document.querySelector(`script[src="${environment.unbluApiUrl}"]`)
    if (existingScript) {
      console.debug('Unblu API script already loaded')
      scriptLoaded = true
      scriptLoading = false
      resolve()
      return
    }

    // Create and load script
    const script = document.createElement('script')
    script.src = environment.unbluApiUrl
    script.async = true
    script.defer = true

    script.onload = () => {
      console.debug('Unblu API script loaded successfully')
      scriptLoaded = true
      scriptLoading = false
      resolve()
    }

    script.onerror = (error) => {
      logWithSuffix('error', 'UNBLU-API-LOAD-FAILED', 'Failed to load Unblu API script:', error)
      scriptLoading = false
      reject(new Error(`Failed to load Unblu API from ${environment.unbluApiUrl}`))
    }

    // Add script to document
    document.head.appendChild(script)
  })

  return loadPromise
}

export function isUnbluApiLoaded(): boolean {
  return scriptLoaded
}

export function resetUnbluApi(): void {
  scriptLoaded = false
  scriptLoading = false
  loadPromise = null
} 